import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
// Constants - Functions
import { protocols } from "../../../../../../config/constants";
import { parseSecondsToMinutes, getProtocolTitle } from "../../../../../../config/functions";
// Components
import { DownloadButton, FileImg } from "./styles";
// Assets
import CSVImg from "../../../../../../assets/ico_csv.svg";

const DownloadCSV = ({ sessionsData = [] }) => {
  const { patientId, protocolId } = useParams();
  const [t] = useTranslation("global");

  const getFileName = () => {
    const protocolTitle = t(getProtocolTitle(protocolId, t));
    const protocolTitleParsed = protocolTitle.replace(" ", "_");
    return `${t("patient")}${patientId}_${protocolTitleParsed}.csv`;
  };

  const generateCSV = () => {
    let headers = [
      `${t("SESSION")}`,
      `${t("STARTING DATE")}`,
      `${t("SESSION DURATION (min)")}`,
      `${t("SESSION STATUS")}`,
      `${t("SCORE")}`,
      `${t("HAND TRACKING")}`,
      `${t("DIFFICULTY")}`,
    ];

    if (Number(protocolId) !== protocols.clinicAndHome.TOWERS.id) {
      headers = headers.concat([
        `${t("PERFORMANCE - REST")}`,
        `${t("PERFORMANCE - MOVEMENTS")}`,
        `${t("FREQUENCY")}`,
        `${t("LEARNABILITY")}`,
      ]);
    }

    const rows = sessionsData.map((session, i) => {
      const sessionDuration = parseSecondsToMinutes(session.sessionDuration).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      let row = [
        i + 1,
        session.STARTING_DATE,
        Number(sessionDuration),
        session.STATUS,
        session.score ? session.score : 0,
        session.handTrackingState ? session.handTrackingState : "NONE",
        session.difficultyLevel ? session.difficultyLevel : "NONE",
      ];

      if (Number(protocolId) !== protocols.clinicAndHome.TOWERS.id) {
        const parsedSuccessRates = session.successRates ? JSON.stringify(session.successRates).replaceAll(",", " - ") : 0;
        const parsedFrequencies = session.frequencies ? JSON.stringify(session.frequencies).replaceAll(",", " - ") : 0;
        const parsedCompletionTimes = session.completionTimes ? JSON.stringify(session.completionTimes).replaceAll(",", " - ") : 0;

        row = row.concat([
          session.restPerformance ? Number(session.restPerformance).toFixed(2) : 0,
          parsedSuccessRates,
          parsedFrequencies,
          parsedCompletionTimes,
        ]);
      }

      return row;
    });

    let csvContent = headers.join(",") + "\r\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\r\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, getFileName());
  };

  return (
    <DownloadButton onClick={generateCSV}>
      <FileImg src={CSVImg} alt="ico-csv" />
    </DownloadButton>
  );
};

export default DownloadCSV;
